import { RefObject, useEffect, useRef } from 'react';

/**
 * Hook that alerts clicks outside of the passed ref
 */
export function useOnClickOutside(
  ref: RefObject<HTMLElement> | RefObject<HTMLElement>[],
  handler: (event: MouseEvent | TouchEvent) => void
) {
  const handlerRef = useRef(handler);
  const refsRef = useRef(ref);

  useEffect(() => {
    handlerRef.current = handler;
  }, [handler]);

  useEffect(() => {
    refsRef.current = ref;
  }, [ref]);

  useEffect(() => {
    const listener = (event: MouseEvent | TouchEvent) => {
      const currentRefs = Array.isArray(refsRef.current) ? refsRef.current : [refsRef.current];

      if (currentRefs.some((r) => r.current && r.current.contains(event.target as Node))) {
        return;
      }

      handlerRef.current(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, []); // Only register once
}
